var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuDots = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39407",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal",
    d: "M5.11 14.278a1.389 1.389 0 1 1-2.778 0 1.389 1.389 0 0 1 2.778 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_2",
    d: "M10.387 9A1.389 1.389 0 1 1 7.61 9a1.389 1.389 0 0 1 2.778 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_3",
    d: "M15.666 9a1.389 1.389 0 1 1-2.777 0 1.389 1.389 0 0 1 2.777 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_4",
    d: "M10.387 3.722a1.389 1.389 0 1 1-2.778 0 1.389 1.389 0 0 1 2.778 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_5",
    d: "M15.666 3.722a1.389 1.389 0 1 1-2.777 0 1.389 1.389 0 0 1 2.777 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_6",
    d: "M5.11 9a1.389 1.389 0 1 1-2.778 0A1.389 1.389 0 0 1 5.11 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_7",
    d: "M10.387 14.278a1.389 1.389 0 1 1-2.778 0 1.389 1.389 0 0 1 2.778 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_8",
    d: "M15.666 14.278a1.389 1.389 0 1 1-2.777 0 1.389 1.389 0 0 1 2.777 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu-kebab-horizontal_9",
    d: "M5.11 3.722a1.389 1.389 0 1 1-2.778 0 1.389 1.389 0 0 1 2.778 0Z"
  })))));
};
export default SvgMenuDots;